module.exports = __webpack_public_path__ + "img/11233816.afee1089.png";